import React, { ReactNode, useEffect, useRef, useState } from "react";
import StatusLoadingIcon from "../../Icons/StatusBar/StatusLoading";
import StatusStopLoadingIcon from "../../Icons/StatusBar/StatusStopLoading";
import "./StatusButton.css";

function getStatusItem(status: KeyValuePair) {
  const statusItem = (
    <div className="status-item">
      <div>{status.key + ": "}</div>
      <div
        style={{
          color: "green",
          marginLeft: 2,
        }}
      >
        {status.value}
      </div>
    </div>
  );
  return statusItem;
}

function getStatusses(statusses: KeyValuePair[]) {
  const statussesView = [];
  for (let i = 0; i < statusses.length; i += 2) {
    const j = i + 1;
    statussesView.push(
      <div
        key={statusses[i].key}
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* upper status item */}
        {getStatusItem(statusses[i])}
        {/* lower status item */}
        {j < statusses.length && getStatusItem(statusses[j])}
      </div>,
    );
  }

  return statussesView;
}
export interface KeyValuePair {
  key: string;
  value: string | ReactNode;
}

type Props = {
  kvps?: KeyValuePair[];
  icon: React.ReactNode;
  id: string;
  onClick: (id: string) => void;
  isActive: boolean;
  animation?: StatusButtonAnimation;
  children?: React.ReactNode;
};

export function StatusDisplay({
  id,
  kvps,
  icon,
  isActive,
  onClick,
  animation,
  children,
}: Props) {
  return (
    <div
      key={id}
      style={{
        display: "flex",
        backgroundColor: isActive ? "white" : "transparent",
      }}
    >
      <StatusButton
        id={id}
        icon={icon}
        isActive={isActive}
        onClick={onClick}
        animation={animation}
      />
      {isActive && kvps && children === undefined && (
        <div
          style={{
            height: "72px",
            display: "flex",
          }}
        >
          {getStatusses(kvps)}
        </div>
      )}
      {isActive && children !== undefined && children}
    </div>
  );
}

export type StatusButtonAnimation =
  | "normal"
  | "loading"
  | "warning"
  | "error"
  | "stop-loading"; // not used at the moment

type StatusButtonProps = {
  icon: React.ReactNode;
  iconInactive?: React.ReactNode;
  id: string;
  onClick: (id: string) => void;
  isActive: boolean;
  animation?: StatusButtonAnimation;
  style?: React.CSSProperties;
};

export function StatusButton({
  id,
  icon,
  isActive,
  onClick,
  animation = "normal",
  style = {},
}: StatusButtonProps) {
  const [animationState, setAnimationState] = useState(
    "normal" as StatusButtonAnimation,
  );
  const animationPreviousState = useRef(animationState);

  useEffect(() => {
    const nextAnimation = animation;
    const prevAnimation = animationPreviousState.current;

    // switch (nextAnimation) {
    //   case "normal":
    //     setAnimationState("stop-loading");
    //     setTimeout(() => {
    //       setAnimationState(nextAnimation);
    //       animationPreviousState.current = animation;
    //     }, 2050);
    //     break;
    //   case "warning":
    //   case "loading":
    // }

    // if (
    //   animationPreviousState.current === "loading" &&
    //   animation !== "loading"
    // )
    // {

    // }
    // else if (animationPreviousState.current !== "loading") {
    //   setAnimationState(animation);
    //   animationPreviousState.current = animation;
    // }
    setAnimationState(animation);
  }, [animation]);

  return (
    <div
      className={
        isActive ? "status-button status-button-active" : "status-button"
      }
      onClick={() => onClick(id)}
    >
      <div
        style={{
          height: "56px",
          width: "56px",
          ...style,
        }}
        className={
          animationState === "error"
            ? "icon-blinking error"
            : animationState === "warning"
            ? "icon-blinking warning"
            : ""
        }
      >
        {icon}
      </div>
      {animationState === "loading" && (
        <StatusLoadingIcon
          className="status-button-loading"
          style={{
            animation: `statusLoading 1.3s cubic-bezier(.33,.86,.6,.33) 0s infinite`,
          }}
        />
      )}
      {/* {animationState === "stop-loading" && (
        <StatusStopLoadingIcon
          className="status-button-stop-loading"
          style={{
            animation: `statusStopLoading 1s ease 2s 1 normal forwards`,
          }}
        />
      )} */}
    </div>
  );
}
